import type { ContentBlock as ContentBlockType } from '../../../shared/types'
import useFooterContent from './useFooterContent'
import styles from './FooterContent.module.scss'
import { ContentBlock } from '../'
import { parentMeta } from '../ContentBlock/type'

interface FooterContentType {
  parentMeta?: parentMeta
  filePath?: string
  contentBlock?: ContentBlockType
}

const FooterContent = (props: FooterContentType) => {
  const { parentMeta, contentBlock, filePath } = props

  const {} = useFooterContent()

  return (
    <ContentBlock
      parentMeta={parentMeta}
      className={styles.footerContentRoot}
      contentBlock={contentBlock}
      filePath={filePath}
    ></ContentBlock>
  )
}

export default FooterContent
